import React from 'react'
import { connect } from 'react-redux'
import GroupSummary from 'components/GroupSummary'
import Card from 'components/Card'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'
import PleaseWait from 'components/PleaseWait'
import GroupTertiaryError from './GroupTertiaryError'
import styles from './SubGroups.css'
import { ListContainer } from './ListContainer'

const GroupsList = ({ content, order }) => {
  if (order?.length) {
    return (
      <ListContainer className={styles.groups_list}>
        {order.map(id => (
          <Card key={id}>
            <GroupSummary group={content[id]} />
          </Card>
        ))}
      </ListContainer>
    )
  } else {
    return <PleaseWait i18nKey="posts.empty_list_placeholder" />
  }
}

const SubGroups = ({
  groups: { map: content, list: { loading, values: order, error } = {} }
}) => {
  let loaded = content ? { content, order, error } : undefined
  return (
    <LoadingLoadedOrExploded
      loading={loading || !(content || error)}
      loaded={loaded}
      error={error && error.message ? error.message : error}
      loadedComponent={GroupsList}
      errorComponent={GroupTertiaryError}
    />
  )
}

const mapStateToProps = ({
  session: { value: profile },
  'sub-groups': groups
}) => ({
  groups,
  profile
})
const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SubGroups)
